import { Action } from "@reduxjs/toolkit";
import { PropertyState } from "./types";
import { isType } from "typescript-fsa";
import { propertyActions } from "./actions";

const initialState: PropertyState = {
  total_items: 0,
  total_pages: 0,
  current_page: 1,
  page_size: 10,
  next_page: null,
  previous_page: null,
  data: [],
  property_categories: [],
  property_types: [],
  property_owners: [],
  cities: [],
  districts: [],
  communes: [],
  popular_places: [],
  features: [],
  selectedPropertyDetail: null,
};

export function PropertyReducer(
  state = initialState,
  action: Action
): PropertyState {
  if (isType(action, propertyActions.fetchProperties.done)) {
    const data = action.payload.result;
    return {
      ...state,
      total_items: data.total_items,
      total_pages: data.total_pages,
      current_page: data.current_page,
      page_size: data.page_size,
      next_page: data.next_page,
      previous_page: data.previous_page,
      data: data.data.map((property) => ({
        id: property.id,
        property_code: property.property_code,
        property_name: property.property_name,
        property_category: property.property_category,
        property_type: property.property_type,
        property_status: property.property_status,
        property_status_display: property.property_status_display,
        is_available: property.is_available,
        sold_rented_at: property.sold_rented_at,
        owner: property.owner,
        city: property.city,
        district: property.district,
        commune: property.commune,
        price: property.price,
        size: property.size,
        land_area: property.land_area,
        bedrooms: property.bedrooms,
        bathrooms: property.bathrooms,
        popular_place: property.popular_place,
        features: property.features,
        youtube_link: property.youtube_link,
        google_map_link: property.google_map_link,
        description: property.description,
        thumbnail_image: property.thumbnail_image,
        property_images: property.property_images,
        is_hot: property.is_hot,
        created_at: property.created_at,
      })),
    };
  }

  if (isType(action, propertyActions.getPropertyCategory.done)) {
    return {
      ...state,
      property_categories: action.payload.result,
    };
  }
  if (isType(action, propertyActions.getPropertyType.done)) {
    return {
      ...state,
      property_types: action.payload.result,
    };
  }
  if (isType(action, propertyActions.getPropertyTypeByCategory.done)) {
    return {
      ...state,
      property_types: action.payload.result,
    };
  }
  if (isType(action, propertyActions.getPropertyOwner.done)) {
    return {
      ...state,
      property_owners: action.payload.result.map(owner => ({
        ...owner,
        other_phone_number: owner.other_phone_number ?? ""
      })),
    };
  }
  if (isType(action, propertyActions.getCity.done)) {
    return {
      ...state,
      cities: action.payload.result,
    };
  }
  if (isType(action, propertyActions.getDistrict.done)) {
    return {
      ...state,
      districts: action.payload.result,
    };
  }
  if (isType(action, propertyActions.getCommune.done)) {
    return {
      ...state,
      communes: action.payload.result,
    };
  }
  if (isType(action, propertyActions.getFeatureList.done)) {
    return {
      ...state,
      features: action.payload.result,
    };
  }
  if (isType(action, propertyActions.getPopularPlaceList.done)) {
    return {
      ...state,
      popular_places: action.payload.result,
    };
  }
  if (isType(action, propertyActions.getPropertyDetails.done)) {
    return {
      ...state,
      selectedPropertyDetail: action.payload.result,
    };
  }
  // If you have actions for popular places and features, add them here similarly

  if (isType(action, propertyActions.resetToInitialState)) {
    return {
      ...initialState,
      selectedPropertyDetail: null,
    };
  }

  return state;
}
